import type { NewsItem } from "@/types";

export const newsList: NewsItem[] = [
  {
    id: "n1",
    title: "《星河远征》定档暑期 导演陈屿揭秘幕后特效制作",
    category: "影视新闻",
    author: "秋霞影视编辑部",
    date: "2025-06-12",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20space%20station%20interior%20behind%20the%20scenes%20with%20crew%20and%20blue%20screen%20lighting%2C%20deep%20navy%20tones%20with%20golden%20accents%2C%20documentary%20style%2C%20high%20detail%2C%20no%20text&width=800&height=520&seq=qx-news-01&orientation=landscape",
    summary:
      "备受期待的科幻巨制《星河远征》正式宣布定档暑期，导演陈屿在采访中分享了影片特效团队历时三年的创作历程。",
    content: [
      "备受期待的科幻电影《星河远征》今日正式宣布定档今年暑期。片方同步发布了一支幕后特辑，首次向观众展示影片中那些震撼宇宙场景的诞生过程。",
      "导演陈屿在采访中透露，为了让太空场景更具真实感，特效团队不仅参考了大量真实航天资料，还搭建了等比例的飞船内景实景棚。\"我们希望观众相信，那个世界是真实存在的。\"陈屿说。",
      "影片讲述了一支远征队穿越星际寻找新家园的故事。制片方表示，影片在保持商业娱乐性的同时，也探讨了人类面对未知时的勇气与抉择。",
    ],
  },
  {
    id: "n2",
    title: "深度影评：从《长夜将尽》看历史题材的新表达",
    category: "影评",
    author: "影评人 · 江离",
    date: "2025-05-28",
    cover:
      "https://readdy.ai/api/search-image?query=Melancholic%20historical%20film%20still%20of%20a%20snowy%20old%20city%20street%20at%20dawn%20with%20a%20solitary%20figure%2C%20muted%20navy%20and%20warm%20sepia%20tones%2C%20atmospheric%20cinematic%20mood%2C%20high%20detail%2C%20no%20text&width=800&height=520&seq=qx-news-02&orientation=landscape",
    summary:
      "《长夜将尽》没有宏大的战争场面，却用最克制的镜头，讲出了最动人的坚守。本文从叙事结构与影像语言两个角度，聊聊它为何值得反复观看。",
    content: [
      "在众多历史题材作品中，《长夜将尽》显得格外安静。它把镜头对准了一个教书先生和他的一群学生，而非烽火连天的战场。",
      "影片最动人之处，在于它相信\"微小\"的力量。一个知识分子的坚持，一间教室里的灯光，都被导演用近乎纪录的方式记录下来，反而产生了巨大的情感张力。",
      "光影的运用是影片的另一个亮点。全片大部分场景都笼罩在低照度之中，直到结尾黎明降临，画面才第一次迎来明亮的暖色。这种视觉节奏，与主题形成了完美的呼应。",
    ],
  },
  {
    id: "n3",
    title: "年度悬疑大剧《都市迷雾》首支预告片发布",
    category: "预告片资讯",
    author: "秋霞影视编辑部",
    date: "2025-04-30",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20urban%20mystery%20series%20still%20of%20a%20foggy%20city%20skyline%20at%20night%20with%20silhouetted%20figure%2C%20deep%20navy%20and%20crimson%20red%20accents%2C%20tense%20cinematic%20atmosphere%2C%20high%20detail%2C%20no%20text&width=800&height=520&seq=qx-news-03&orientation=landscape",
    summary:
      "由陈屿执导的悬疑剧《都市迷雾》发布首支预告片，一分钟的镜头里信息量巨大，网友直呼\"看不够\"。",
    content: [
      "《都市迷雾》首支预告片今日上线。预告以一段断续的电话录音开场，配合快速闪烁的城市夜景，迅速营造出紧张的氛围。",
      "预告片中，主演周予安饰演的调查记者不断追问真相，而每一个被问到的人似乎都藏着秘密。片尾一句\"你确定要知道吗\"，让悬念拉满。",
      "该剧预计将在下半年与观众见面，具体播出时间尚未公布。",
    ],
  },
  {
    id: "n4",
    title: "秋霞影视年度片单公布 三十部新作蓄势待发",
    category: "影视新闻",
    author: "秋霞影视编辑部",
    date: "2025-03-21",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20collage%20of%20glowing%20film%20screens%20in%20a%20dark%20gallery%20with%20deep%20navy%20and%20golden%20light%2C%20abstract%20artistic%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=520&seq=qx-news-04&orientation=landscape",
    summary:
      "秋霞影视正式公布年度内容片单，涵盖电影、电视剧与纪录片三大板块，共计三十部新作将在未来一年陆续上线。",
    content: [
      "秋霞影视今日公布年度片单，共发布三十部新作，题材横跨科幻、悬疑、古装、都市与历史等多个类型。",
      "从片单来看，平台在保持原有优势题材的同时，明显加大了对现实题材与精品短剧的投入。多部作品邀请了实力派演员与成熟导演团队参与。",
      "相关负责人表示，未来将继续以优质内容为核心，为用户提供更丰富的观看选择与更舒适的使用体验。",
    ],
  },
  {
    id: "n5",
    title: "《时间回廊》如何用时间循环讲好一个关于选择的故事",
    category: "影评",
    author: "影评人 · 沈明",
    date: "2025-02-14",
    cover:
      "https://readdy.ai/api/search-image?query=Surreal%20sci-fi%20film%20still%20of%20an%20infinite%20mirrored%20corridor%20with%20glowing%20clock%20fragments%2C%20deep%20navy%20and%20teal%20tones%2C%20mysterious%20cinematic%20atmosphere%2C%20high%20detail%2C%20no%20text&width=800&height=520&seq=qx-news-05&orientation=landscape",
    summary:
      "时间循环早已不是新鲜设定，但《时间回廊》依然拍出了新意。本文聊一聊它如何把\"重复\"变成了一种力量。",
    content: [
      "《时间回廊》表面上是一个关于时间循环的科幻故事，内核却是一个关于\"选择\"的寓言。",
      "主角每天醒来都是同一个清晨，看似是被困住，实则获得了无数次重新选择的机会。影片巧妙地用重复的日常，反衬出人物内心的变化。",
      "当最后一天到来，主角终于做出了与前几次截然不同的决定。那一刻，观众才真正理解影片想说的话：我们无法重来，但每一次选择都值得认真对待。",
    ],
  },
];